:host {
  display: block;

  ul {
    padding: 0;
    margin: 0;
  }
}
